<div class="order-page-title" id="top">
  <div class="edit-button">
    <eps-button (buttonClick)="backClicked()" label="SHARED.BUTTONS.BACK"></eps-button>
  </div>
  <div class="content">
    <div class="title">
      <app-title title="STOCK_COUNT.PRINT.TITLE"></app-title>
    </div>
  </div>
</div>
<stock-count-create-location [shipTos]="shipTos" [isPrint]="true"> </stock-count-create-location>
